<template>
  <div class="galeria">
    <div v-if="showMonthGalery == true && empreendimentoGalerias">
      <carousel
        v-if="showMonthGalery == true && empreendimentoGalerias.length >= 1"
        :per-page="1"
        :paginationPadding="5"
        :paginationSize="15"
        :paginationActiveColor="'#13182c'"
        :perPageCustom="[[480, 1], [768, 2], [1024, 3]]"
        :loop="false"
        :autoplay="false"
        :paginationEnabled="false"
        :navigationEnabled="true"
        navigationNextLabel='<i class="fa fa-chevron-right button_right"></i> Próxima'
        navigationPrevLabel='Anterior <i class="fa fa-chevron-left button_left" aria-hidden="true"></i>'
      >
        <slide v-for="(galery,index) in empreendimentoGalerias" :key="index">
            <div class="galeria__image ui-image--cover" @click="openViewer(index)" :style="'background-image: url('+galery.image+')'">
              <div class="galeria__image__name ui-image--contain-bottom">
                <div class="galeria__image__title">
                  {{galery.title}}
                </div>
              </div>
            </div>
        </slide>
      </carousel>
    </div>
    <!-- repetir imagens aqui também, pois aqui são as imagens da galeria -->
    <div class="images" v-viewer="{movable: false, title: false, scalable: false, title: [1, (image) => `${image.alt}`]}" style="display: none;">
      <img v-for="(galery,index) in empreendimentoGalerias" :key="index" :src="galery.image" :alt="galery.title">
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
import { mapGetters } from 'vuex'
Vue.use(Viewer)
export default {
  components: {
    Carousel,
    Slide
  },
  data () {
    return {
      showMonthGalery: false
    }
  },
  computed: {
    ...mapGetters([
      'empreendimentoGalerias'
    ])
  },
  methods: {
    aciveTab (a) {
      this.tabOne = a
    },
    openViewer (id) {
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.view(id)
      viewer.show()
    }
  },
  created () {
    this.$store.dispatch('showEmpreendimentoGaleria', this.$route.params.slug)
      .then(() => {
        this.showMonthGalery = true
      })
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.viewer-one-to-one{
  display: none;
}
.galeria {
  &__image {
    cursor: pointer;
    height: 650px;
    position: relative;
    transition: all 0.3s;
    &:hover {
      opacity: 0.8;
      transition: all 0.3s;
    }
  }
  &__image__name {
    background-image: url(../../assets/img/bg_galeria.png);
    bottom: 0;
    height: 100%;
    left: 0;
    position: absolute;
    text-align: center;
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: bottom;
  }
  &__image__title {
    bottom: 80px;
    color: white;
    font-size: 24px;
    font-style: italic;
    font-weight: 600;
    position: absolute;
    text-align: center;
    width: 100%;
  }
  @media (max-width: 1200px) {
    &__image {
      height: 500px;
    }
  }
  @media (max-width: 767px) {
     &__image__title {
      bottom: 50px;
      font-size: 20px;
     }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaGaleria.vue